module.exports = __webpack_public_path__ + "img/automoto.b1902587.png";